module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title",
    staticStyle: {
      "padding-top": "2.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p')]), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Acnowlegment#ack",
      "id": "ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#list",
      "id": "list"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#intro",
      "id": "intro"
    }
  }, [_vm._v("Introduction: Journeys, Festivals, and the Making of National Pasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter1#ch1",
      "id": "ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Van Riebeeck’s Pasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter2#ch2",
      "id": "ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. “We Build a Nation”: The Festival of Unity and Exclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Contesting Van Riebeeck’s Nation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. “"), _c('em', [_vm._v("’n Fees vir die Oog”")]), _vm._v(" [A Festival/Feast for the Eye]: Looking in on the 1952 Jan Van Riebeeck Tercentenary Festival Fair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Local and National Pasts: The Journeys of the Mail Coach “Settlers” through the Eastern Cape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter6#conl",
      "id": "conl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Post Van Riebeeck")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Note#notes",
      "id": "notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Bibliography#bio",
      "id": "bio",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Index#index",
      "id": "index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba43f48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Content.vue
// module id = 72
// module chunks = 0